<template>
    <div id="cookienotice" v-show="show">
        <div id="cookietopbar"></div>
        <div class="insidecookie">
            {{ $t('layout.cookie.message') }}
            <div class="accept" @click="acceptCookie">
                <span>
                    > {{ $t('layout.cookie.yes') }}
                </span>
            </div>
            <div class="decline" @click="goAway">
                <span>
                    > {{ $t('layout.cookie.no') }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data () {
            return {
                show: true
            }
        },
        mounted () {
            this.checkCookieAccept()
        },
        methods: {
            checkCookieAccept () {
                const accepted = localStorage.getItem('cookies_accepted')
                if (accepted) {
                    this.show = false
                }
            },
            acceptCookie () {
                localStorage.setItem('cookies_accepted', true)
                this.show = false
            },
            goAway () {
                const lang = this.$i18n.locale

                if (lang === 'da') {
                    window.location.href = 'https://www.google.dk/search?q=alternativ+til+københavns+bedste+software+bureau'

                    return
                }

                window.location.href = 'https://www.google.dk/search?q=alternative+to+copenhagens+best+software+agency'
            }
        }
    }
</script>
<style lang="scss" scoped>
    #cookienotice{
        animation: fadeIn 1s ease-in-out;
        position: fixed;
        bottom: 10px;
        left: 10px;
        width: 300px;
        background: rgba(0,0,0,0.9);
        box-shadow: 0 0px 35px rgba(50,50,93,.5), 0 5px 15px rgba(0,0,0,.07);
        z-index: 1000;
        color: #fff;
        font-family: Consolas, monospace;
        font-size: 0.8rem;
        line-height: 1.1rem;
        font-weight: 100;
        border-radius: 4px;
        .accept{
            color: #007bff;
            margin-top: 10px;
            margin-bottom: 5px;
        }
        .decline{
            color: #ff2200;
        }
        .accept span:hover{
            cursor: pointer;
            color: darken(#007bff, 10%);
        }
        .decline span:hover{
            cursor: pointer;
            color: darken(#ff2200, 10%);
        }
        .insidecookie{
            padding: 10px 15px;
        }
        #cookietopbar{
            height: 20px;
            width: 100%;
            background: url('/static/images/cookienotice.png');
            background-size: cover;
            border-radius: 4px 4px 0 0;
        }
    }
    @media screen and (max-width:992px){
        #cookienotice{
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 70px;
            max-width: calc(100vw - 30px);
        }
    }
    @keyframes fadeIn {
        0%{
            opacity: 0;
            transform: translate(-100%,100%);
        }
        100%{
            opacity: 1;
            transform: none;
        }
    }
</style>



// WEBPACK FOOTER //
// cookie-notice.vue?625fae66